import { V1Service } from '@zelos/codegen/apis';
import { regex } from '@zelos/shared/constants/regex';
import { setReactHookFormErrorByErrors, toTypedApiError } from '@zelos/shared/lib/typed-api-error';
import { useAtomValue } from 'jotai';
import Image from 'next/image';
import { useForm } from 'react-hook-form';
import { tempFindUserAtom } from '..';
import { InputAboveDiv, InputWrapDiv, InputWrapSpan } from '../SignInput';
import { ResetPasswordForm, ContentFirstDiv, ContentSecondDiv, BottomBtn } from './ResetPasswordComponents';
import Input from '@/components/comm/Input';
import RequiredAsterisk from '@/components/comm/RequiredAsterisk';
import { createErrorToast, showToast } from '@/lib/toast';
import icMessage from '@/public/images/ic-message.svg';

type ResetPasswordType = { email: string };

const ResetPassword = () => {
  const { email } = useAtomValue(tempFindUserAtom);
  const { register, handleSubmit, setError, formState: { errors } } = useForm<ResetPasswordType>();

  const resetPasswordSubmit = async ({ email }: ResetPasswordType) => {
    try {
      await V1Service.v1UsersPasswordsFindPasswordCreate({
        requestBody: { email },
      });
      showToast({ text: '이메일이 발송 되었습니다.' });
    } catch (error) {
      const errorBody = toTypedApiError(error);
      if (errorBody) {
        setReactHookFormErrorByErrors(setError, errorBody.errors);
        createErrorToast(errorBody, 'detail');
      } else {
        throw error;
      }
    }
  };

  return (
    <ResetPasswordForm noValidate onSubmit={handleSubmit(resetPasswordSubmit)}>
      <ContentFirstDiv>비밀번호 재설정</ContentFirstDiv>
      <ContentSecondDiv>비밀번호를 재설정 할 이메일을 입력해주세요.<br />입력된 메일로 자세한 안내를 보내드립니다.</ContentSecondDiv>
      <InputWrapDiv>
        <InputAboveDiv>
          <InputWrapSpan>
            <span>재설정 안내 받을 이메일</span>
            <RequiredAsterisk />
          </InputWrapSpan>
        </InputAboveDiv>
        <Input
          type="email"
          placeholder="이메일을 입력해 주세요"
          error={errors.email}
          defaultValue={email}
          {...register('email', {
            required: '이메일을 입력해 주세요',
            pattern: {
              value: regex.email,
              message: '올바르지 않은 이메일 형식입니다.',
            },
          })}
          start={<Image src={icMessage} alt="message" />}
        />
      </InputWrapDiv>
      <BottomBtn type="submit">비밀번호 재설정 메일 보내기</BottomBtn>
    </ResetPasswordForm>
  );
};

export default ResetPassword;
